import React from 'react'
import Marquee from "react-fast-marquee";

//Scss
import "./marquee.scss";

const marquee = () => {
    return (
        <div id="marquee">
            <div className="wrapper2">
                <Marquee
                    className="marquee-gradient"
                    gradient="false"
                    gradientWidth="0"
                    direction="right"
                    speed="100"
                    delay="0"
                >
                    <div className="marquee-text">
                        User Experience  .  Wireframing  .  Prototyping  .  User Interface  . &nbsp;
                    </div>
                </Marquee>
                <Marquee
                    className="marquee-gradient"
                    gradient="false"
                    gradientWidth="0"
                    direction="left"
                    speed="100"
                    delay="0"
                >
                    <div className="marquee-text">
                        Illustrations  .  Backend  .  Full Stack Development  .  Frontend  . &nbsp;
                    </div>
                </Marquee>
                <Marquee
                    className="marquee-gradient"
                    gradient="false"
                    gradientWidth="0"
                    direction="right"
                    speed="100"
                    delay="0"
                >
                    <div className="marquee-text">
                        Graphic Design  .  Branding  .  Content Creation  .  Motion Graphic  . &nbsp;
                    </div>
                </Marquee>
            </div>
        </div>
    )
}

export default marquee
